import React from "react";

import { HStack, Text, Stack } from "@chakra-ui/react";

import { CustomButton } from "../../../../../components/CustomButton";
import { RadioButtonField } from "../../../../../components/RadioButtonField";

export const IncluirFiliacao = ({ openModal, filiacao, fieldName }) => {
  return (
    <HStack spacing={{ base: "10px", sm: "30px" }} mt="20px">
      <Text
        color="#5F6377"
        fontWeight={500}
        fontSize="14px"
        lineHeight="19.6px"
        minW="35px">
        {filiacao}
      </Text>
      <CustomButton
        onClick={() => openModal(filiacao)}
        label="Incluir"
        height="30px"
      />
      <Stack direction={{ base: "column", sm: "row" }}>
        {fieldName === "situacaoMae" ? (
          <RadioButtonField
            fieldName={fieldName}
            value="Desconhecida"
            label="Desconhecida"
          />
        ) : (
          <RadioButtonField
            fieldName={fieldName}
            value="Desconhecido"
            label="Desconhecido"
          />
        )}
        <RadioButtonField
          fieldName={fieldName}
          value="Sem Informação"
          label="Sem Informação"
        />
      </Stack>
    </HStack>
  );
};
